import { Component } from "@angular/core";
import { ALLOWED_CHARACTERS } from "src/config/allowed-characters.config";
import { PrefixTextComponent } from "../../prefix-text.component";
import { TemplateTextComponent } from "../../templates/template-text/template-text.component";
import { MaxLength } from "../../types/MaxLength";

@Component({
  selector: "app-prefix-cd1",
  imports: [TemplateTextComponent],
  templateUrl: "./prefix-cd1.component.html",
  styleUrl: "./prefix-cd1.component.less",
})
export class PrefixCd1Component extends PrefixTextComponent {
  public maxlength: MaxLength;

  public constructor() {
    super({
      defaultValue: "0000000",
      updateOn: "blur",
    });
    this.maxlength = 12;
    this.required = false;
    this.characters = ALLOWED_CHARACTERS["cd1"];
  }

  public override onControlValue(value: string | null): void {
    if (value) {
      if (/^[0-9]+$/.test(value)) value = value.padStart(7, "0");
      super.onControlValue(value);
      this.updateControl(value, false);
    }
  }
}
